import React, { useEffect, useState } from 'react';
import PanelList from 'Components/PanelList/PanelList';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import './CostSpreadsheet.css';
import Panel from 'Components/Panel/Panel';
import InputField from 'Components/Input/InputField';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';
import GridItemsSpreadsheet from './GridItemsSpreadsheet/GridItemsSpreadsheet';

const CostSpreadsheet = (
    {
        itemInValidation,
        itemsMonth,
        comboBoxYear,
        showNewMonthPanel,
        showDeleteMonthPanel,
        closeCostSpreadsheet,
        loadingItemsMonth,
        updatePanelCostSpreadsheet,
        rowIndexSelected,
        onUpdateShowDetailItem,
        onUpdateItemsMonth,
        onUpdateItemInValidation,
        onUpdateComboBoxYear,
        onUpdateShowNewMonthPanel,
        onUpdateShowDeleteMonthPanel,
        onUpdatePanelCostSpreadsheet,
        onUpdateRowIndexSelected,
        onUpdateLoadingItemsMonth
    }) => {
    const [showSubtitles, setShowSubtitles] = useState(false);
    const [showCostMinute, setShowCostMinute] = useState(false);

    const [costMinuteExpected, setCostMinuteExpected] = useState(null);
    const [costMinuteReal, setCostMinuteReal] = useState(null);
    const [costMinuteReceived, setCostMinuteReceived] = useState(null);


    useEffect(() => {
        onUpdatePanelCostSpreadsheet(false)
        const fetchData = async () => {
            const parameters = {
                currentMonth: comboBoxYear
            }

            onUpdateItemsMonth(null)
            onUpdateLoadingItemsMonth(true)
            const resultItemsDays = await ExecuteAxios.api('get', '/cost-day/sum-cost-month/', { params: parameters });
            onUpdateItemsMonth(resultItemsDays);
            setCostMinuteExpected(null)
            setCostMinuteReal(null)
            setCostMinuteReceived(null)
            const resultMinutes = await ExecuteAxios.api('get', '/cost-day/get-minutes-values/', { params: parameters });
            onUpdateLoadingItemsMonth(false)

            if (resultMinutes) {
                setCostMinuteExpected(resultMinutes.costMinuteExpected)
                setCostMinuteReal(resultMinutes.costMinuteReal)
                setCostMinuteReceived(resultMinutes.costMinuteReceived)
            }
        }
        fetchData();
    }, [comboBoxYear, updatePanelCostSpreadsheet === true])

    useEffect(() => {
        if (itemInValidation) {
            onUpdateShowDetailItem(true);
        } else {
            onUpdateShowDetailItem(false);
        }
    }, [])

    const styleComboBoxYear = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginLeft: '10px',
        alignItems: 'center'
    }

    function componentRightFilterYear() {
        return (
            <Panel style={styleComboBoxYear}>
                <ReactDataPickerComp
                    selected={comboBoxYear}
                    onChange={(date) => { onUpdateComboBoxYear(date) }}
                    wrapperClassName={'width-full'}
                    className='cost-spreedsheet-width-date cursor-pointer'
                    showYearPicker={true}
                    dateFormat="yyyy"
                    setter={onUpdateComboBoxYear}
                />
            </Panel>
        )
    }

    function reorderElements(originalElements) {
        if (!originalElements) {
            return null;
        }
        const reorderedElements = [...originalElements].sort((a, b) => {
            return a.order - b.order;
        });

        return reorderedElements;
    }

    const gridItems = reorderElements(GridItemsSpreadsheet.getGridItems(itemsMonth));
    const valuesItems = GridItemsSpreadsheet.getValuesItems(itemsMonth);

    function onUpdateInsert() {
        onUpdateShowDeleteMonthPanel(false)
        onUpdateShowNewMonthPanel(true)
    }

    function onUpdateDelete() {
        onUpdateShowNewMonthPanel(false)
        onUpdateShowDeleteMonthPanel(true)
    }

    const setShowPanelSubtitles = () => {
        setShowSubtitles(!showSubtitles);
    }

    const setShowPanelCostMinute = () => {
        setShowCostMinute(!showCostMinute);
    }

    const subtitlesStyleCostPerDay = {
        padding: '5px',
        cursor: 'default'
    }

    const subtitleDescriptionStyleCostPerDay = {
        marginLeft: '10px'
    }

    const costMinuteStyleMain = {
        padding: '5px',
        cursor: 'default',
        flexDirection: 'row',
        display: 'flex',
        alignItems: 'center'
    }

    const costMinuteStyleSpan = {
        display: 'inline-flex',
        marginLeft: '10px',
        width: '250px'
    }

    const costMinuteStyleAttribute = {
        width: '125px',
        textAlign: 'center',
        display: 'flex'
    }

    function getColorStyle(valueToDisplay) {
        let colorStyle;
        if (valueToDisplay === 0) {
            colorStyle = { backgroundColor: 'purple' };
        } else if (valueToDisplay === 1) {
            colorStyle = { backgroundColor: 'green' };
        } else if (valueToDisplay === 2) {
            colorStyle = { backgroundColor: 'red' };
        }

        return (
            <div
                style={{
                    width: '15px',
                    height: '15px',
                    borderRadius: '50%',
                    display: 'inline-block',
                    ...colorStyle
                }}
            ></div>
        )
    }

    function getButtonToShowSubtitles() {
        return (
            <div className="main-balloon-cost-month">
                <div style={{ position: 'absolute', bottom: '0px' }}>
                    {showSubtitles && (
                        <div className="balloon-cost-month">
                            {getSubtitlesContent()}
                        </div>
                    )}
                    <div className="title-balloon-cost-month"
                        onClick={setShowPanelSubtitles}
                    >
                        Legenda
                    </div>
                </div>
            </div>
        );
    }

    function getSubtitlesContent() {
        return (
            <div style={{ backgroundColor: '#f5f5f5' }}>
                <div style={subtitlesStyleCostPerDay}>
                    {getColorStyle(0)}
                    <span style={subtitleDescriptionStyleCostPerDay}>Itens pendentes</span>
                </div>
                <div style={subtitlesStyleCostPerDay}>
                    {getColorStyle(1)}
                    <span style={subtitleDescriptionStyleCostPerDay}>Orçamento dentro do limite </span>
                </div>
                <div style={subtitlesStyleCostPerDay}>
                    {getColorStyle(2)}
                    <span style={subtitleDescriptionStyleCostPerDay}>Orçamento excedeu o limite </span>
                </div>
            </div>
        );
    }

    function getButtonToShowMinuteCost() {
        return (
            <div className="main-balloon-minute-cost">
                <div style={{ position: 'absolute', bottom: '0px' }}>
                    {showCostMinute && (
                        <div className="balloon-minute-cost">
                            {getCostMinute()}
                        </div>
                    )}
                    <div className="title-balloon-minute-cost"
                        onClick={setShowPanelCostMinute}
                    >
                        Custo minuto
                    </div>
                </div>
            </div>
        );
    }

    function getCostMinute() {
        return (
            <div style={{ backgroundColor: '#f5f5f5' }}>
                <div style={costMinuteStyleMain}>
                    <span style={costMinuteStyleSpan}>Custo minuto previsto</span>
                    <InputField
                        setAttribute={setCostMinuteExpected}
                        value={costMinuteExpected}
                        readOnly={true}
                        disabled={true}
                        style={costMinuteStyleAttribute}
                        decimalScale={2}
                    />
                </div>
                <div style={costMinuteStyleMain}>
                    <span style={costMinuteStyleSpan}>Custo minuto real</span>
                    <InputField
                        setAttribute={setCostMinuteReal}
                        value={costMinuteReal}
                        readOnly={true}
                        disabled={true}
                        style={costMinuteStyleAttribute}
                        decimalScale={2}
                    />
                </div>
                {/* <div style={costMinuteStyleMain}>
                    <span style={costMinuteStyleSpan}>Média custo minuto recebido</span>
                    <InputField
                        setAttribute={setCostMinuteReceived}
                        value={costMinuteReceived}
                        readOnly={true}
                        disabled={true}
                        style={costMinuteStyleAttribute}
                    />
                </div> */}
            </div>
        );
    }

    const mainCostSpreadsheet = {
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 1s ease-in-out',
        zIndex: '10',
        height: '100%'
    };

    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '95%',
        zIndex: '20',
        position: 'relative'
    };

    return (
        <Panel style={mainCostSpreadsheet} className={closeCostSpreadsheet ? 'main-modal two left' : 'main-modal'} >
            <Panel titlePage={'Orçamento anual'}
                style={panelListStyle}
                inserting={false}
                setInserting={onUpdateInsert}
                canViewCRUD={true}
                enableDelete={true}
                canDelete={!showDeleteMonthPanel}
                forcedDeleteButton={true}
                enableNewRecord={true}
                canNewRecord={!showNewMonthPanel}
                deleteFunction={onUpdateDelete}
                recordsSelected={[]}
                subtitlesPanelBottom={
                    <div style={{ display: 'flex', flexDirection: 'row', height: '5%', width: '100%' }}>
                        {getButtonToShowSubtitles()}
                        {getButtonToShowMinuteCost()}
                    </div>}
                componentRightFilter={componentRightFilterYear()}
            >
                <LoadingIndicator loaded={!loadingItemsMonth}>
                    <PanelList
                        onUpdateIdSelected={null}
                        idsSelected={[]}
                        list={valuesItems}
                        onClickCell={onUpdateRowIndexSelected}
                        onDoubleBlickCell={onUpdateItemInValidation}
                        advanced={true}
                        millisecondsBalloon={1500}
                        cursorCell='pointer'
                        alternateColors={true}
                        rowIndexSelected={rowIndexSelected}
                        alredyValidateQuery={!valuesItems}
                    >
                        {gridItems}
                    </PanelList>
                </LoadingIndicator>
            </Panel >
        </Panel >
    )
};

export default CostSpreadsheet;

